<template>
  <li class="EventOccasion">
    <div class="EventOccasion__inner">
      <div class="EventOccasion__detail EventOccasion__date">
        <span class="day">{{ date.day }} {{ date.monthShort }}</span>
        <span class="year">{{ date.year }}</span>
      </div>

      <div class="EventOccasion__flex-container">
        <div class="EventOccasion__info">
          <div v-if="showSubtitle && occasionData.subTitle" class="EventOccasion__subtitle">
            {{ occasionData.subTitle }}
          </div>
          <div class="EventOccasion__detail EventOccasion__day-time">
            {{ date.weekday }},
            {{ occasionData.startTime }} <span v-if="occasionData.showEndTime">- {{ occasionData.endTime }}</span>
          </div>
          <div class="EventOccasion__detail EventOccasion__location">
            {{ occasionData.stage }}
          </div>
        </div>

        <div v-if="occasionData.notice" class="EventOccasion__detail EventOccasion__notice">
          {{ occasionData.notice }}
        </div>

        <div
          :class="{
          'EventOccasion__tickets--alert': occasionData.salesStatus.alert,
          }"
          class="EventOccasion__detail EventOccasion__tickets"
        >
          {{ occasionData.salesStatus.text }}
        </div>
      </div>

      <div
        class="EventOccasion__book"
      >
        <a
          v-if="occasionData.salesStatus.forSale && !hidePriceInfo"
          :aria-label="translations.book + ' ' + occasionData.eventName + ' - ' + date.day + ' ' + date.monthLong"
          :href="occasionData.purchaseUrl"
          class="button button--book button--colored"
          :class="'book-' + occasionData.eventId + '-inEvent'"
        >
          {{ translations.book }}
        </a>
        <span
          v-if="occasionData.soldOut"
          class="EventOccasion__tickets--alert">{{ translations.soldOut }}</span>
      </div>
    </div>
  </li>
</template>

<script>
import {mapGetters} from 'vuex'

let convertDate = (rawDate) => {
  rawDate = rawDate.toString();
  return rawDate.substring(0, 4) + "-" + rawDate.substring(4, 6) + "-" + rawDate.substring(6);
}

export default {
  name: "EventOccasion",
  data() {
    return {
      translations: {
        ticketLeft: Drupal.t('ticket left'),
        ticketsLeft: Drupal.t('tickets left'),
        soldOut: Drupal.t('Sold out'),
        book: Drupal.t('Book it')
      },
      hidePriceInfo: drupalSettings.hide_price_info || false,
      date: {
        dateString: '',
        day: '',
        weekday: '',
        monthShort: '',
        monthLong: '',
        year: ''
      },
    }
  },
  props: {
    occasionData: {
      type: Object
    }
  },
  beforeMount() {
    // Format all date parameters.
    this.date.dateString = new Date(this.occasionData.date);
    this.date.day = this.date.dateString.toLocaleDateString('sv', {day: 'numeric'});
    this.date.weekday = this.date.dateString.toLocaleDateString('sv', {weekday: 'long'});
    this.date.monthShort = this.date.dateString.toLocaleDateString('sv', {month: 'short'});
    this.date.monthShort = this.date.monthShort.length > 3 ? this.date.monthShort.slice(0, -1) : this.date.monthShort;
    this.date.monthLong = this.date.dateString.toLocaleDateString('sv', {month: 'long'})
    this.date.year = this.date.dateString.toLocaleDateString('sv', {year: 'numeric'})
  },
  methods: {
    convertTime(rawTime) {
      rawTime = rawTime.toString();
      return rawTime.substring(0, rawTime.length - 2) + ':' + rawTime.substring(rawTime.length - 2);
    }
  },
  computed: {
    ...mapGetters({
      eventData: 'getEventData',
      showSubtitle: 'getShowSubtitleState'
    })
  }
}
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.EventOccasion {
  padding: 10px 15px 12px;
  @include breakpoint($tablet) {
    padding: 10px 20px 12px;
  }

  &:nth-child(odd) {
    background: $light-grey;
  }
}

.EventOccasion__inner {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 688px;
}

.EventOccasion__detail {
  font-size: 15px;
  line-height: 1.2;
}

.EventOccasion__date {
  display: flex;
  flex-direction: column;
  min-width: 50px;

  .day {
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .year {
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
  }
}

.EventOccasion__flex-container {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;

  @include breakpoint($phone-mini) {
    margin-left: 20px;
  }
  @include breakpoint($tablet) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 20px;
  }
}

.EventOccasion__info {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.EventOccasion__subtitle {
  font-family: $neue-plak;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 3px;
  text-transform: uppercase;
}

.EventOccasion__day-time {
  font-weight: 600;
  text-transform: capitalize;
  @include breakpoint($tablet) {
    min-width: 102px;
  }
}

.EventOccasion__location {
  margin-bottom: 5px;
  @include breakpoint($tablet) {
    margin-bottom: 0;
  }
}

.EventOccasion__notice {
  font-weight: 600;
  margin-bottom: 5px;

  @include breakpoint($tablet) {
    flex: 1 1 auto;
    margin-bottom: 0;
    margin-left: 30px;
    margin-right: 30px;
  }
}

.EventOccasion__tickets {
  @include breakpoint($tablet) {
    text-align: right;
  }
}

.EventOccasion__tickets--alert {
  color: $red;
  font-weight: 600;
}

.EventOccasion__book {
  margin-left: 25px;
  min-width: 52px;
}
</style>
